// First-run onboarding state. Phase 0 is client-side: a per-user localStorage
// flag, keyed by userId so a shared browser or an account switch doesn't wrongly
// suppress (or re-trigger) the tour for the wrong person.
const TOUR_SEEN_PREFIX = 'landscope_onboarding_tour_seen:';
export const hasSeenTour = (userId) => {
    try {
        return localStorage.getItem(`${TOUR_SEEN_PREFIX}${userId}`) === '1';
    }
    catch (_a) {
        return false;
    }
};
export const markTourSeen = (userId) => {
    try {
        localStorage.setItem(`${TOUR_SEEN_PREFIX}${userId}`, '1');
    }
    catch (_a) {
        // Private mode / storage disabled — the tour simply re-shows next session.
    }
};
// Latch for the initial camera fly-to. The first-run tour waits for this so it
// triggers AFTER the opening flight, never during it. A plain module flag (not
// React state) so a late-arming tour can read "already done" without missing the
// one-shot 'camera:initialFlyComplete' event.
let initialFlyComplete = false;
export const isInitialFlyComplete = () => initialFlyComplete;
export const markInitialFlyComplete = () => { initialFlyComplete = true; };
